import { render } from "./TopicsView.vue?vue&type=template&id=504271ec"
import script from "./TopicsView.vue?vue&type=script&lang=ts"
export * from "./TopicsView.vue?vue&type=script&lang=ts"
script.render = render

export default script